import { FC } from 'react';
import CustomButton, { ButtonType } from 'components/custom-button/CustomButton';
import { EditTableIcon, ExportIcon } from 'assets/icons';

interface InvoicesTableActionsProps {
  onExportClick: () => void;
  onEditTableClick: () => void;
}

const InvoicesTableActions: FC<InvoicesTableActionsProps> = ({ onExportClick, onEditTableClick }) => {
  return (
    <div className="flex w-full items-center justify-end gap-4">
      <CustomButton
        id="export-invoices-button"
        aria-label="Export invoices"
        StartIcon={ExportIcon}
        startIconStyle="path-fill-current text-primaryText"
        type={ButtonType.SECONDARY}
        className="h-8 border border-gray-1 bg-transparent py-1.5 px-3 text-sbase font-semibold
         text-primaryText focus:outline-none focus:ring-2 focus:ring-primary"
        onClick={onExportClick}>
        <span className="text-sbase font-medium">Export</span>
      </CustomButton>

      <CustomButton
        id="edit-table-button"
        aria-label="Edit table"
        StartIcon={EditTableIcon}
        startIconStyle="path-fill-current text-primaryText"
        type={ButtonType.SECONDARY}
        className="h-8 border border-gray-1 bg-transparent py-2 px-3 text-sbase font-semibold
         text-primaryText focus:outline-none focus:ring-2 focus:ring-primary"
        onClick={onEditTableClick}>
        <span className="text-sbase font-medium">Edit table</span>
      </CustomButton>
    </div>
  );
};

export default InvoicesTableActions;
